<template>
  <v-container class="questionnaire-step-bar-container">
    <v-progress-linear
      :value="progress"
      background-color="rgb(255, 255, 255)"
      color="green"
      height="25"
      reactive
    >
    </v-progress-linear>

    <div class="step-number-section">
      {{ step }} / {{ steps }}
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'QuestionnaireStepBar',
  props: {
    step: Number,
    steps: Number,
  },
  computed: {
    progress () {
      return (this.step / this.steps) * 100
    },
  },
}
</script>

<style lang="scss" scoped>
.step-number-section {
  height: 28px;
  margin-top: 14px;

  display: flex;
  justify-content: center;
  align-items: center;

  font-family: "Sansation Bold", Serif;
  font-size: 18px;
  color: $textDarkMuted;
}

::v-deep {
  .v-progress-linear {
    background: #ffffff !important;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 4px;
    opacity: 1;
  }

  .v-progress-linear__determinate {
    border-radius: 4px;
  }
}
</style>
